import { FieldType, DefaultFormTableSchema } from "./types";
export class GuarantorTableSchema extends DefaultFormTableSchema {
    constructor() {
        super({
            columnData: {
                customerNumberCombined: { fieldType: FieldType.Text }
            }
        });
    }
}
//# sourceMappingURL=GuarantorTableSchema.js.map